export default __webpack_public_path__ + "c75ab845a274de60235b88c075e6db96.png";